export default function PHP_connection_status() {
  return (
    <div>
      <h1>PHP_connection_status</h1>
    </div>
  );
}
